import * as React from "react";
import { css } from "aphrodite";
import { StarNumRating } from "main/javascripts/components/molecules/StarRating/StarNumRating";
import { Paragraph } from "main/javascripts/components/atoms/Paragraph/Paragraph";
import { Icon } from "main/javascripts/components/atoms/Icon/Icon";
import { H1 } from "main/javascripts/components/atoms/H1";
import { HeaderStyle } from "./HeaderStyle";

export interface IProps {
  name: string;
  address: string;
  rating: number;
}
const HeaderComponent: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  return (
    <div>
      <H1>{props.name}</H1>
      {props.rating ? <StarNumRating rating={props.rating} /> : ""}
      <Paragraph>
        <>
          <Icon styleKey="pin" styles={HeaderStyle.icon} />
          <span className={css(HeaderStyle.address)}>{props.address}</span>
        </>
      </Paragraph>
    </div>
  );
};
export const Header: any = React.memo(HeaderComponent);
